import React from "react";
import PropTypes from "prop-types";
import RCTimePicker from "react-time-picker";

import { TimePickerContainer } from "./TimePicker.styles";

export const TimePicker = ({ ...props }) => {
  return (
    <TimePickerContainer>
      <RCTimePicker
        disableClock
        format="HH:mm"
        clockClassName="close"
        {...props}
      />
    </TimePickerContainer>
  );
};

TimePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
};
